// @flow
import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import ScrollToTop from "app/components/ScrollToTop";
import { MuiThemeProvider } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import theme from "app/themes/default.js";
import routes from "./routes";

type Props = {};

class App extends React.Component<Props> {
  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <ScrollToTop>
            <Switch>
              {routes.map((route: any) => {
                return (
                  <Route
                    key={route.path || "404"}
                    path={route.path}
                    exact={route.exact}
                    render={props => <route.page {...props} />}
                  />
                );
              })}
            </Switch>
          </ScrollToTop>
        </BrowserRouter>
      </MuiThemeProvider>
    );
  }
}

const Component = App;
export default Component;
